module.exports = __webpack_public_path__ + "static/media/ca_8.5aca1b45.png";